// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2295":"889e53cd","2394":"889e53cd","2751":"a799ea89","4017":"a799ea89","4859":"d53466ca","6348":"889e53cd","7780":"85b5bc0b"}[chunkId] + ".chunk.css";
};